import { defineComponent as _defineComponent } from 'vue'
import mapboxgl, { AnyLayer } from 'mapbox-gl'
import { computed } from 'vue'
import VectorTileSource from '../mapbox/VectorTileSource.vue'
import LayerGroup from '../mapbox/LayerGroup.vue'
import { useGetMapLayersQuery } from '@/api/mapping'
import { locationPinStyle } from './styles/location-pin'


export default /*#__PURE__*/_defineComponent({
  __name: 'LocationsLayer',
  props: {
    layerId: null,
    sourceId: null,
    hiddenFeatureIds: null,
    before: null,
    hideLayer: { type: Boolean }
  },
  emits: ["click"],
  setup(__props: any, { emit: emits }: { emit: ({
  (
    event: 'click',
    data: mapboxgl.MapboxGeoJSONFeature[],
    eventData: mapboxgl.MapMouseEvent & mapboxgl.EventData
  )
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  layerId: string
  sourceId: string
  hiddenFeatureIds?: (string | number)[]
  before?: string
  hideLayer?: boolean
}

const { data } = useGetMapLayersQuery()





const handleClick = (
  data: mapboxgl.MapboxGeoJSONFeature[],
  eventData: mapboxgl.MapMouseEvent & mapboxgl.EventData
) => {
  emits('click', data, eventData)
}

const url = computed(() => {
  return data.value?.locations.url
})

const filters = computed(() => {
  const filter: any[] = ['all']

  const ids = props.hiddenFeatureIds || []
  if (ids.length > 0) {
    filter.push(['!', ['in', ['id'], ['literal', ids]]])
  }

  return filter
})

const layers: AnyLayer[] = [
  {
    id: props.layerId,
    type: 'symbol',
    'source-layer': 'get_locations_by_org_and_tenant',
    layout: {
      ...locationPinStyle.layout,
    },
    paint: {
      ...locationPinStyle.paint,
    },
  },
]

return { __sfc: true,data, props, emits, handleClick, url, filters, layers, VectorTileSource, LayerGroup }
}

})